module.exports = __webpack_public_path__ + "2e39ec90aeea62d286d4f9b67cb21767.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/mustache-brown-s.png
// module id = 1203
// module chunks = 0